(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discover-menu"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const scrollContainer = document.querySelector('.discover-menu__scroll-container');
    if (!scrollContainer) return;

    let touchStartX = 0;
    let touchStartY = 0;
    let isHorizontalGesture = false;

    function handleTouchStart(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isHorizontalGesture = false;
    }

    function handleTouchMove(e) {
      if (!touchStartX || !touchStartY) return;

      const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
      const deltaY = Math.abs(e.touches[0].clientY - touchStartY);

      if (deltaX > 10 || deltaY > 10) {
        if (!isHorizontalGesture) {
          isHorizontalGesture = deltaX > deltaY;
        }

        if (isHorizontalGesture) {
          const canScrollLeft = scrollContainer.scrollLeft > 0;
          const canScrollRight = scrollContainer.scrollLeft < (scrollContainer.scrollWidth - scrollContainer.clientWidth);
          
          if (canScrollLeft || canScrollRight) {
            e.stopPropagation();
          }
        }
      }
    }

    function handleTouchEnd() {
      touchStartX = 0;
      touchStartY = 0;
      isHorizontalGesture = false;
    }

    scrollContainer.addEventListener('touchstart', handleTouchStart, { passive: true });
    scrollContainer.addEventListener('touchmove', handleTouchMove, { passive: true });
    scrollContainer.addEventListener('touchend', handleTouchEnd, { passive: true });
    scrollContainer.addEventListener('touchcancel', handleTouchEnd, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
